module.exports = __webpack_public_path__ + "e7bf017c54b7d4f0c1da20fad27f2643.ttf";